import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function NoLuggageIcon(props: IconProps) {
    return <Icon {...props} iconKey={"no_luggage"}/>
}
